import Core from '_abstracts/core'
import getScriptContext from '_abstracts/libs/get-script-context'
import Constants from 'semprefamilia/constants'

Core.Tasks.add([
    // Monta a configuração do tema
    () => {
        Core.Config.parse(Constants[Core.Config.get('stage')])
    },
    // Chama os scripts do tema
    () => {
        // Tarefas do tema
        Core.Tasks.add(Core.Events.PAGE_LOADING,
            [
                'async#semprefamilia-_back'
            ]
        )

        Core.Tasks.add(Core.Events.PAGE_COMPLETE,
            [
                `async#${getScriptContext()}`
            ]
        )
    }
])

// Exemplos de tasks simples
// Recebe 2 parametros
// 1) Array de entidades que se espera pelo status finished
// 2) Array Funções/callback que serão executados
// Executado apenas quando 'nome-entidade' estiver com o status 'finished'
// Core.Tasks.add(['nome-entidade'],
//     [
//         () => {
//             console.log("Finalizou 'nome-entidade'")
//         }
//     ]
// )

// Recebe apenas 1 parâmetro
// 1) Array de funções/callback que serão executados
// Executado imediatamente
// Core.Tasks.add(
//     [
//         () => {
//             Core.Status.update('nome-entidade', 'status', 'started')

//             Core.Status.update('nome-entidade', 'status', 'finished')

//             console.log("definiu status de 'nome-entidade'")
//         }
//     ]
// )

// Exemplos de tasks de entidades que já funcionam no sistema
// Espera o status 'finished' de content
// O status finished de content é definido dentro da classe _back/modules/content
// Core.Tasks.add(['content'],
//     [
//         () => {
//             console.log('content complete')
//         }
//     ]
// )

// Espera o status 'finished' de user
// Core.Tasks.add(['user'],
//     [
//         () => {
//             console.log('user complete')
//         }
//     ]
// )

// Espera o status 'finished' de user e content
// Core.Tasks.add(['user', 'content'],
//     [
//         () => {
//             console.log('user/content complete')
//         }
//     ]
// )
